import { Navigate, Routes, Route } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import Layout from './components/Layout/Layout'
import Dashboard from './components/Dashboard/Dashboard'
import Agents from './components/Agents/Agents'
import PhoneNumbers from './components/PhoneNumbers/PhoneNumbers'
import Calls from './components/Calls/Calls'
import Conversations from './components/Conversations/Conversations'
import Pipeline from './components/Pipeline/Pipeline'
import Settings from './components/Settings/Settings'
import Admin from './components/Admin/Admin'
import Developer from './components/Developer/Developer'
import Landing from './components/Public/Landing'
import Login from './components/Public/Login'
import Register from './components/Public/Register'
import ProtectedRoute from './components/Public/ProtectedRoute'
import BillingPage from './components/Billing/BillingPage'
import OnboardingWizard from './components/Onboarding/OnboardingWizard'
import VerifyEmail from './components/Public/VerifyEmail'
import AcceptInvite from './components/Public/AcceptInvite'

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/app" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="agents" element={<Agents />} />
            <Route path="phone-numbers" element={<PhoneNumbers />} />
            <Route path="calls" element={<Calls />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="conversations" element={<Conversations />} />
            <Route path="developer" element={<Developer />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<Admin />} />
            <Route path="billing" element={<BillingPage />} />
          </Route>
          <Route path="/app/onboarding" element={<OnboardingWizard />} />
        </Route>

        <Route path="/agents" element={<Navigate to="/app/agents" replace />} />
        <Route path="/phone-numbers" element={<Navigate to="/app/phone-numbers" replace />} />
        <Route path="/calls" element={<Navigate to="/app/calls" replace />} />
        <Route path="/pipeline" element={<Navigate to="/app/pipeline" replace />} />
        <Route path="/conversations" element={<Navigate to="/app/conversations" replace />} />
        <Route path="/developer" element={<Navigate to="/app/developer" replace />} />
        <Route path="/settings" element={<Navigate to="/app/settings" replace />} />
        <Route path="/admin" element={<Navigate to="/app/admin" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
    </div>
  )
}

export default App
